import { store } from '../redux/store';

// 以下の記事からRedux Toolkitはダウンロードすることは目的外であるため、fetchで作成
// https://github.com/reduxjs/redux-toolkit/issues/1522
export const downloadCsv = async (type: string, date: string | undefined) => {
  const query = new URLSearchParams();
  query.append('type', type);
  type === 'workTimes' && date && query.append('month', date);
  const state = store.getState();
  const token = state.tokens.accessToken;
  const res = await fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/download-csv?${query}`,
    {
      method: 'GET',
      headers: {
        Accept: 'text/csv',
        Authorization: `Bearer ${token}`,
      },
    }
  ).then((res) => {
    if (!res.ok) {
      throw res;
    }

    return res;
  });

  return res;
};
